import { billingAndShippingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

pageContainerStyles.promoCodeGridItem = {
    width: 0,
};

pageContainerStyles.paymentDetailsAndCreditCardDetailsAndAddressGridItem = {
    width: [12, 12, 6, 8, 8],
    css: css`
        > ${GridWrapper} {
            > ${GridOffset} {
                > ${GridItemStyle} {
                    &:first-child {
                        > div[class^="Wrapper"] {
                            > div[class^="sc"] {
                                padding: 10px;
                            }
                        }
                    }
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        order: 2;
                    `,
                    null,
                    css`
                        order: 1;
                    `,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};

billingAndShippingAddressStyles.billingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > ${GridWrapper} {
            > ${GridOffset} {
                width: 100%;
                margin: 0;
                > ${GridItemStyle} {
                    > ${TypographyStyle} {
                        color: ${getColor("secondary")};
                    }
                    > address[class^="sc"] {
                        > ${TypographyStyle} {
                            color: ${getColor("secondary")};
                        }
                    }
                }
            }
        }
    `,
};

billingAndShippingAddressStyles.shippingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > ${GridWrapper} {
            > ${GridOffset} {
                width: 100%;
                margin: 0;
                > ${GridItemStyle} {
                    > ${TypographyStyle} {
                        color: ${getColor("secondary")};
                    }
                    > address[class^="sc"] {
                        > ${TypographyStyle} {
                            color: ${getColor("secondary")};
                        }
                    }
                }
            }
        }
    `,
};

billingAndShippingAddressStyles.carrierGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
        > ${TypographyStyle} {
            color: ${getColor("secondary")};
        }
    `,
};

billingAndShippingAddressStyles.shippingServiceGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
        > ${TypographyStyle} {
            color: ${getColor("secondary")};
        }
    `,
};

billingAndShippingAddressStyles.deliveryDateGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
        > ${TypographyStyle} {
            color: ${getColor("secondary")};
        }
    `,
};

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        margin-left: auto;
    `,
};

checkoutReviewAndSubmitHeaderStyles.placeOrderButton = {
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: unset;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.headingText = {
    variant: "h1",
    // css: css`
    //     margin-bottom: 0;
    // `,
};

checkoutReviewAndSubmitHeaderStyles.gridItem = {
    width: 12,
    css: css`
        padding-bottom: 0px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
